import { render, staticRenderFns } from "./CopyToClipboardV2.vue?vue&type=template&id=6ad8995b&"
import script from "./CopyToClipboardV2.vue?vue&type=script&lang=js&"
export * from "./CopyToClipboardV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports